// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GradingDimensionDescription } from './gradingDimensionDescription';

/**
 * For each dimensions: is it applicable (bool) and which demands fall under this dimension
 */
export type TaskAnalysisDimensions = { [key: string]: GradingDimensionDescription };
